import { ZoneModal } from '@digital-retail/falabella-ui-cross-components';
import PropTypes from 'prop-types';
import constants from '../../../../config/constants';
import SelectVariant from '../../../Cart/SelectVariant/SelectVariant';
import DeliveryErrorDisplay from '../DeliveryErrorDisplay';
import DeliveryOptionsContent from '../DeliveryOptionsContent/DeliveryOptionsContent';
import DeliveryOptionsWithMaps from '../DeliveryOptionsContent/DeliveryOptionsWithMaps';

const { AVAILABILITY_PICKUPINSTORE, AVAILABILITY_STOCKINSTORE, AVAILABILITY_HOMEDELIVERY } = constants;

const ModalContentRenderer = ({
  screen,
  isPickupInStore,
  isStockInStore,
  selectVariantProps,
  zoneModalProps,
  mapProps,
  contentProps,
  errorProps,
  selectedType,
  setIsMapView,
}) => {
  const { isError, comunaName, parentStateName, hasActiveErrors } = errorProps;

  const errorTypeMap = {
    [AVAILABILITY_PICKUPINSTORE]: 'PickupInStore',
    [AVAILABILITY_HOMEDELIVERY]: 'HomeDelivery',
    [AVAILABILITY_STOCKINSTORE]: 'StockInStore',
  };

  const errorKey = errorTypeMap[selectedType];

  if (screen === 'screen1') {
    return <SelectVariant {...selectVariantProps} />;
  }

  if (screen === 'screen2') {
    return <ZoneModal {...zoneModalProps} />;
  }

  if (screen === 'screen3') {
    if (hasActiveErrors && errorKey && isError[errorKey] && isError[errorKey].isError) {
      setIsMapView(false);
      return (
        <DeliveryErrorDisplay
          errorState={isError}
          comunaName={comunaName}
          parentStateName={parentStateName}
          selectedType={selectedType}
        />
      );
    }
    if (isPickupInStore || isStockInStore) {
      return <DeliveryOptionsWithMaps {...mapProps} />;
    }
    return <DeliveryOptionsContent {...contentProps} />;
  }

  return null;
};

ModalContentRenderer.propTypes = {
  screen: PropTypes.string.isRequired,
  isPickupInStore: PropTypes.bool.isRequired,
  isStockInStore: PropTypes.bool.isRequired,
  selectVariantProps: PropTypes.object,
  zoneModalProps: PropTypes.object,
  mapProps: PropTypes.object,
  contentProps: PropTypes.object,
  errorProps: PropTypes.object,
  selectedType: PropTypes.string.isRequired,
  setIsMapView: PropTypes.func.isRequired,
};

ModalContentRenderer.defaultProps = {
  selectVariantProps: {},
  zoneModalProps: {},
  mapProps: {},
  contentProps: {},
  errorProps: {
    isError: {},
    comunaName: '',
    parentStateName: '',
    hasActiveErrors: false,
  },
};

export default ModalContentRenderer;
